import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithConfirmationLayout.scss';

export default function DialogWithConfirmationLayout(props) {
  const {
    character = '!',
    children,
    selfClose,
    onYesClick,
    footerClassName,
    cancelLabel = 'Cancel',
    yesLabel = 'Yes',
    content,
    layoutType,
  } = props;

  const clickYesHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character}
      layoutType={layoutType}
      headerClassName="dialog-with-confirmation-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-confirmation-layout-footer-wrapper')}
      footer={
        <div className="els-btn-group-right">
          <ButtonWithIcon
            type="tertiary"
            size="small"
            sprite="Close"
            linkIconSize="s"
            iconRight
            onClick={selfClose}
            className="e2e-dialog-cancel">
            {cancelLabel}
          </ButtonWithIcon>
          <ButtonWithIcon
            type="primary"
            size="small"
            sprite="ChevronRight"
            linkIconSize="s"
            iconRight
            onClick={clickYesHandler}
            className="e2e-dialog-yes">
            {yesLabel}
          </ButtonWithIcon>
        </div>
      }>
      {children || content}
    </DialogsWithIcon>
  );
}

DialogWithConfirmationLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func.isRequired,
  character: PropTypes.string,
  children: PropTypes.node,
  layoutType: PropTypes.string,
  footerClassName: PropTypes.string,
  cancelLabel: PropTypes.string,
  yesLabel: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
